'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef, useMemo } from 'react';
import { CarouselIndicatorContainer, Indicator } from './elements';
import { useComponentDeprecation } from '../../util';
/**
 * @deprecated
 */
export const CarouselIndicator = /*#__PURE__*/forwardRef(({
  currentIndex,
  totalItems,
  contained = false,
  indicatorType = 'dots',
  handleCarouselIndicatorClick,
  ...rest
}, fRef) => {
  useComponentDeprecation({
    name: 'CarouselIndicator',
    version: '5'
  });
  const indicators = useMemo(() => Array.from({
    length: totalItems
  }, (_, index) => /*#__PURE__*/React.createElement(Indicator, {
    indicatorType: indicatorType,
    key: index,
    "data-current": index === currentIndex,
    onClick: () => handleCarouselIndicatorClick === null || handleCarouselIndicatorClick === void 0 ? void 0 : handleCarouselIndicatorClick(index)
  })), [currentIndex, totalItems, indicatorType]);
  return /*#__PURE__*/React.createElement(CarouselIndicatorContainer, _extends({
    "data-aui": "carousel-indicator",
    contained: contained
  }, rest, {
    ref: fRef
  }), indicators);
});